import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";

const ImageLightbox = ({ src, onClose, toolbarButtons = [] }) => (
  <Lightbox
    open
    close={onClose}
    slides={[{ src }]}
    plugins={[Zoom]}
    carousel={{ finite: true }}
    render={{
      buttonPrev: () => null,
      buttonNext: () => null,
    }}
    toolbar={{
      buttons: [...toolbarButtons, "zoom", "close"],
    }}
  />
);

export default ImageLightbox;
